module.exports = __webpack_public_path__ + "../assets/img/f3b03735aab4b736532dbe30843d1775.svg";